import React from 'react';

const styles = {
  header: {
    padding: '40px 0 32px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    borderBottom: '1px solid var(--border)', marginBottom: '60px',
  },
  logo: { display: 'flex', alignItems: 'center', gap: '18px' },
  logoText: { fontFamily: 'var(--font-head)', fontSize: '26px', fontWeight: 900, letterSpacing: '0.12em', color: '#fff' },
  logoSub: { fontFamily: 'var(--font-mono)', fontSize: '11px', color: 'var(--neon)', letterSpacing: '0.2em', marginTop: '3px' },
  statusPill: {
    display: 'flex', alignItems: 'center', gap: '10px',
    fontFamily: 'var(--font-mono)', fontSize: '13px', color: 'var(--neon)',
    padding: '8px 18px', border: '1px solid var(--border)', borderRadius: '3px',
  },
  dot: { width: '8px', height: '8px', borderRadius: '50%', background: 'var(--neon)', animation: 'blink 2s infinite' },
};

export default function Header() {
  return (
    <header style={styles.header}>
      <div style={styles.logo}>
        <svg width="44" height="44" viewBox="0 0 40 40" fill="none">
          <polygon points="20,2 38,11 38,29 20,38 2,29 2,11" stroke="#00ffe7" strokeWidth="1.2" fill="rgba(0,255,231,0.05)" />
          <polygon points="20,8 32,14 32,26 20,32 8,26 8,14" stroke="#00ffe7" strokeWidth="0.7" fill="rgba(0,255,231,0.04)" strokeDasharray="3 2" />
          <circle cx="20" cy="20" r="4" fill="#00ffe7" />
          <line x1="20" y1="2" x2="20" y2="8" stroke="#00ffe7" strokeWidth="1" />
          <line x1="20" y1="32" x2="20" y2="38" stroke="#00ffe7" strokeWidth="1" />
          <line x1="2" y1="11" x2="8" y2="14" stroke="#00ffe7" strokeWidth="1" />
          <line x1="32" y1="26" x2="38" y2="29" stroke="#00ffe7" strokeWidth="1" />
          <line x1="38" y1="11" x2="32" y2="14" stroke="#00ffe7" strokeWidth="1" />
          <line x1="8" y1="26" x2="2" y2="29" stroke="#00ffe7" strokeWidth="1" />
        </svg>
        <div>
          <div style={styles.logoText}>NEXUS</div>
          <div style={styles.logoSub}>AI BUSINESS INTELLIGENCE</div>
        </div>
      </div>
      <div style={styles.statusPill}>
        <div style={styles.dot} />
        SYSTEM ONLINE
      </div>
    </header>
  );
}
